import { localeToOption, setLocale } from '@/features/workspaceEdit/components/LocalizationSelector/helpers';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '@/localization';
import { LOCALIZATION_OPTIONS, LocalizationTitle } from '@/features/workspaceEdit/components/LocalizationSelector/constants';

const variants = {
  default: 'text-blue-800',
  light: 'text-[#fff]',
};

export default function LanguageToggle({ variant = 'default' }) {
  const { t } = useTranslation();

  const value = useMemo(() => {
    const temp = localeToOption(i18n.language);

    return {
      ...temp,
      label: t(`localization:${temp.label as LocalizationTitle}`),
    };
  }, [i18n.language]);

  const options = LOCALIZATION_OPTIONS.map((option) => ({
    ...option,
    label: t(`localization:${option.label as LocalizationTitle}`),
  }));

  const handleChange = (value) => {
    setLocale(value.id as string);
  };

  return (
    <div className='absolute right-8 top-8 flex items-center gap-2 text-[0.85rem] font-semibold text-gray-700'>
      {options?.map((item, index) => {
        const isActive = item.id === value.id;

        return (
          <div key={item.id} className='flex items-center gap-2'>
            <button
              type='button'
              onClick={() => handleChange(item)}
              className={`inline-flex items-center gap-1 text-[1.1rem] uppercase ${variants[variant]}
                ${isActive ? 'cursor-default font-bold' : 'cursor-pointer hover:underline'}`}
            >
              <span className={`leading-none ${isActive ? 'underline' : ''}`}>{item.id}</span>
            </button>

            {index < options?.length - 1 && <span className={`select-none ${variants[variant]}`}>|</span>}
          </div>
        );
      })}
    </div>
  );
}
